module.exports = __webpack_public_path__ + "static/img/5.c1bf91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/5.png
// module id = tQAm
// module chunks = 35